/** Conflict reasons from backend comparison_data (mobile parity). */
export const ConflictChange = {
  EXPECTED_QTY_CHANGE: 'expected_qty_changed',
  ITEM_DELETED: 'item_deleted',
  ITEM_ADDED: 'item_added',
} as const;

export type PickingFilterChip = {
  id: number;
  name: string;
  displayText: string;
  constraint: string;
  active: boolean;
  isSelected: boolean;
};

export const createOrderPickingFiltersSet1 = (): PickingFilterChip[] => [
  {
    id: 1,
    name: 'Yes',
    displayText: 'Yes',
    constraint: 'done_picked_qty=true',
    active: false,
    isSelected: false,
  },
  {
    id: 2,
    name: 'No',
    displayText: 'No',
    constraint: 'done_picked_qty=false',
    active: false,
    isSelected: false,
  },
];

export const createOrderPickingFiltersSet2 = (): PickingFilterChip[] => [
  {
    id: 1,
    name: '0',
    displayText: '0',
    constraint: 'pickedQty=zero',
    active: false,
    isSelected: false,
  },
  {
    id: 2,
    name: 'Empty',
    displayText: 'Empty',
    constraint: 'pickedQty=empty',
    active: false,
    isSelected: false,
  },
  {
    id: 3,
    name: 'Short',
    displayText: 'Short',
    constraint: 'short=true',
    active: false,
    isSelected: false,
  },
  {
    id: 4,
    name: 'Match',
    displayText: 'Match',
    constraint: 'match=true',
    active: false,
    isSelected: false,
  },
  {
    id: 5,
    name: 'Over',
    displayText: 'Over',
    constraint: 'over=true',
    active: false,
    isSelected: false,
  },
];
